var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"Actia"}},[_c('SovecoNavBar'),_c('div',{staticClass:"box has-text-centered"},[_c('span',{staticClass:"button is-success",on:{"click":function($event){return _vm.doGetActia()}}},[_vm._v(" Vai al sito ACTIA")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }